(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  /*
   * ==========================================
   * STICKY HEADER
   * ==========================================
   */

  class StickyHeader extends HTMLElement {


    constructor() {

      super();

    }



    connectedCallback() {


      this.header =
        document.querySelector('.section-header');


      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always';


      this.headerBounds = {};


      this.setHeaderHeight();



      window
        .matchMedia('(max-width: 990px)')
        .addEventListener(
          'change',
          this.setHeaderHeight.bind(this)
        );



      if (this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-sticky'
        );

      }



      this.currentScrollTop = 0;

      this.preventReveal = false;



      this.onScrollHandler =
        this.onScroll.bind(this);



      this.hideHeaderOnScrollUp =
        () => (this.preventReveal = true);



      this.addEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );



      window.addEventListener(
        'scroll',
        this.onScrollHandler,
        false
      );



      this.createObserver();

    }



    setHeaderHeight() {


      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

    }



    disconnectedCallback() {


      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );


      window.removeEventListener(
        'scroll',
        this.onScrollHandler
      );

    }



    createObserver() {


      let observer =
        new IntersectionObserver(
          (entries, observer) => {


            this.headerBounds =
              entries[0].intersectionRect;


            observer.disconnect();


          }
        );


      observer.observe(this.header);

    }



    onScroll() {


      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop;



      if (

        scrollTop > this.currentScrollTop &&

        scrollTop > this.headerBounds.bottom

      ) {


        this.header.classList.add(
          'scrolled-past-header'
        );


        this.classList.add(
          'scrolled-past-header'
        );


        if (this.preventHide) {
          return;
        }


        requestAnimationFrame(
          this.hide.bind(this)
        );


      }


      else if (

        scrollTop < this.currentScrollTop &&

        scrollTop > this.headerBounds.bottom

      ) {


        this.header.classList.add(
          'scrolled-past-header'
        );


        this.classList.add(
          'scrolled-past-header'
        );



        if (!this.preventReveal) {


          requestAnimationFrame(
            this.reveal.bind(this)
          );


        }


        else {


          window.clearTimeout(
            this.isScrolling
          );


          this.isScrolling =
            setTimeout(
              () => {

                this.preventReveal = false;

              },
              66
            );


          requestAnimationFrame(
            this.hide.bind(this)
          );


        }


      }


      else if (

        scrollTop <= this.headerBounds.top

      ) {


        this.header.classList.remove(
          'scrolled-past-header'
        );


        this.classList.remove(
          'scrolled-past-header'
        );


        requestAnimationFrame(
          this.reset.bind(this)
        );


      }



      this.currentScrollTop =
        scrollTop;

    }



    hide() {


      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );


    }



    reveal() {


      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.header.classList.remove(
        'shopify-section-header-hidden'
      );


    }



    reset() {


      if (this.headerIsAlwaysSticky) {
        return;
      }


      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );


    }


  }



  if (!customElements.get('sticky-header')) {


    customElements.define(
      'sticky-header',
      StickyHeader
    );


  }



  /*
   * ==========================================
   * SALESFIRE SEARCH
   * ==========================================
   *
   * IMPORTANT:
   *
   * Salesfire selector:
   *
   * #SalesfireSearch
   *
   * We deliberately focus the input DIRECTLY
   * inside the user's click event.
   *
   * There is NO setTimeout here.
   *
   * This is particularly important on mobile,
   * because iOS/Android expect focus to happen
   * directly from the user's touch.
   *
   */


  function initialiseSalesfireSearch() {

    const searchToggle =
      document.querySelector(
        '[data-salesfire-search-toggle]'
      );

    const searchPanel =
      document.querySelector(
        '[data-salesfire-search-panel]'
      );

    const searchClose =
      document.querySelector(
        '[data-salesfire-search-close]'
      );

    const searchInput =
      document.querySelector(
        '#SalesfireSearch'
      );

    const clearButton =
      document.querySelector(
        '.salesfire-search-clear'
      );


    if (
      !searchToggle ||
      !searchPanel ||
      !searchInput
    ) {
      return;
    }


    /*
     * Prevent Shopify section reloads
     * attaching the handler twice.
     */

    if (
      searchToggle.dataset.salesfireInitialised === 'true'
    ) {
      return;
    }

    searchToggle.dataset.salesfireInitialised =
      'true';


    function updateClearButton() {

      if (!clearButton) return;

      clearButton.classList.toggle(
        'is-visible',
        searchInput.value.trim().length > 0
      );

    }


    function closeSearch() {

      searchPanel.classList.add(
        'hidden'
      );

      document.body.classList.remove(
        'active-search'
      );

      searchInput.blur();

    }


    /*
     * OPEN SEARCH
     *
     * Keep focus directly inside the click event.
     * This is important for Salesfire on mobile.
     */

    searchToggle.addEventListener(
      'click',
      function(event) {

        event.preventDefault();

        searchPanel.classList.remove(
          'hidden'
        );

        document.body.classList.add(
          'active-search'
        );

        updateClearButton();

        searchInput.focus();

      }
    );


    /*
     * INPUT / CLEAR
     */

    searchInput.addEventListener(
      'input',
      updateClearButton
    );


    if (clearButton) {

      clearButton.addEventListener(
        'click',
        function(event) {

          event.preventDefault();

          searchInput.value = '';

          searchInput.focus();

          searchInput.dispatchEvent(
            new Event(
              'input',
              {
                bubbles: true
              }
            )
          );

          updateClearButton();

        }
      );

    }


    /*
     * CLOSE SEARCH
     */

    if (searchClose) {

      searchClose.addEventListener(
        'click',
        function(event) {

          event.preventDefault();

          closeSearch();

        }
      );

    }


    /*
     * Salesfire opens its results/overlay outside the
     * header search panel. When the user moves into that
     * overlay, close the header panel underneath it so
     * closing Salesfire does not reveal another search
     * layer which then needs a second Close click.
     */

    searchInput.addEventListener(
      'blur',
      function() {

        requestAnimationFrame(
          function() {

            if (
              !searchPanel.classList.contains('hidden') &&
              !searchPanel.contains(document.activeElement)
            ) {

              closeSearch();

            }

          }
        );

      }
    );


    /*
     * Also collapse the underlying header panel when the
     * user clicks anywhere outside it while it is open.
     * This covers Salesfire result clicks on browsers where
     * the input does not reliably emit blur before the click.
     */

    document.addEventListener(
      'pointerdown',
      function(event) {

        if (
          searchPanel.classList.contains('hidden') ||
          searchPanel.contains(event.target) ||
          searchToggle.contains(event.target)
        ) {
          return;
        }

        closeSearch();

      }
    );


    /*
     * Escape should never leave either the active-search
     * body state or the underlying header panel behind.
     */

    document.addEventListener(
      'keydown',
      function(event) {

        if (
          event.key === 'Escape' &&
          !searchPanel.classList.contains('hidden')
        ) {

          closeSearch();

        }

      }
    );


    updateClearButton();

  }


  /*
   * Initialise immediately if the page
   * has already loaded.
   */

  if (document.readyState === 'loading') {


    document.addEventListener(
      'DOMContentLoaded',
      initialiseSalesfireSearch
    );


  }

  else {


    initialiseSalesfireSearch();


  }



  /*
   * Shopify Theme Editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    initialiseSalesfireSearch
  );



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('[data-section-type="marquee"]');
    const sectionId = section ? section.getAttribute('data-section-id') : null;
    const textPath = sectionId ? section.querySelector('#text-path-' + sectionId) : null;

    if (!textPath) {
      console.warn('Text path element not found');
      return;
    }

    // Animation variables
    let startTime = null;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const duration = isMobile ? 120000 : 50000;
    const pathLength = 5000;

    function animateTextPath(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const progress = (elapsed % duration) / duration;

      // Calculate offset so text moves in reverse direction
      // Reverse the original calculation to move from 0 to -pathLength
      let offset = -progress * pathLength;

      textPath.setAttribute('startOffset', offset);
      requestAnimationFrame(animateTextPath);
    }

    // Start the animation
    requestAnimationFrame(animateTextPath);
  });

  } catch(e) { console.error(e); }
})();
})();
